import AnemoBackground from '../assets/elements/anemo.jpg';
import CryoBackground from '../assets/elements/cryo.jpg';
import ElectroBackground from '../assets/elements/electro.jpg';
import GeoBackground from '../assets/elements/geo.jpg';
import HydroBackground from '../assets/elements/hydro.jpg';
import PyroBackground from '../assets/elements/pyro.jpg';
import DendroBackground from '../assets/elements/dendro.webp';

export default {
  Anemo: AnemoBackground,
  Cryo: CryoBackground,
  Electro: ElectroBackground,
  Geo: GeoBackground,
  Hydro: HydroBackground,
  Pyro: PyroBackground,
  Dendro: DendroBackground
};
